const version ='1.6.7'
export default version
console.log(version)
